/*
 * Header
 */

// Header Space
document.addEventListener("DOMContentLoaded", function() {
  var header = document.querySelector("#header"); // ヘッダーの要素を取得

  if (header) {
    var headerHeight = header.offsetHeight; // ヘッダーの高さを取得
    document.documentElement.style.setProperty("--header-height", headerHeight + "px"); // CSS変数に設定
  }
});


/*
 * Drawer
 */

// コンテンツを表示

document.addEventListener("click", function (event) {
  const handle = event.target.closest(".drawer-handle");
  const drawer = document.getElementById("drawer");
  const drawerInbox = document.querySelector("#drawer .inbox");
  const activeContent = document.querySelector("#drawer .drawer-content[data-active]");

  if (handle) {
    const target = handle.dataset.target;
    if (!target) return;

    const newContent = document.querySelector(`#drawer .drawer-content[drawer-data="${target}"]`);

    if (!document.body.classList.contains("--draweropen")) {
      // drawer が閉じている場合は開く
      document.body.classList.add("--draweropen");
    }

    if (activeContent !== newContent) {
      // 現在表示されているコンテンツを非表示
      if (activeContent) activeContent.removeAttribute("data-active");

      // 新しいコンテンツを表示
      if (newContent) newContent.setAttribute("data-active", "true");

      // アクティブなボタンを切り替え
      document.querySelectorAll(".drawer-handle").forEach((btn) => btn.classList.remove("active"));
      handle.classList.add("active");
    } else {
      // 同じボタンを押した場合は閉じる
      document.body.classList.remove("--draweropen");
      newContent.removeAttribute("data-active");
      handle.classList.remove("active");
    }
  } else if (document.body.classList.contains("--draweropen")) {
    // drawer 外をクリックしたら閉じる
    if (drawer.contains(event.target) && !drawerInbox.contains(event.target)) {
      document.body.classList.remove("--draweropen");
      if (activeContent) activeContent.removeAttribute("data-active");
      document.querySelectorAll(".drawer-handle").forEach((btn) => btn.classList.remove("active"));
    }
  }
});


/*
 * Facebool pageplugin responsive

var htmlStr = $('#pageplugin').html();
var timer = false;
$(window).resize(function () {
  if (timer !== false) {
    clearTimeout(timer);
  }
  timer = setTimeout(function() {
    $('#pageplugin').html(htmlStr);
    window.FB.XFBML.parse();
  }, 200);
});
*/
